import PropTypes from 'prop-types';
import styles from './FJRatioChoose.module.less';
import ArrowIcon from '../../../assets/svg/button-right-2.svg?react';
import { useState } from 'react';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import CheckIcon from '../../../assets/svg/choose.svg?react';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import FJDropdownNew from '../../components/FJDropDown/FJDropdownNew';
import FJUtil from '../../../util/FJUtil';

const FJRatioChoose = props => {
    const { currentRatio, changeRatio, list, className, buttonClassName } = props;
    const [showSideModel, setShowSideModel] = useState(false);
    // 添加响应式位置状态
    const curRatioObj = list.find(item => item.name === currentRatio);

    const handleOnMouseDown = e => {
        showSideModel && e.stopPropagation();
    };

    const handleChangeRatio = ratio => {
        changeRatio(ratio);
        setShowSideModel(false);
    };
    const renderTrigger = ({ ref, onClick }) => {
        return (
            <div
                className={classNames(styles.ratio_btu, buttonClassName)}
                onClick={onClick}
                onMouseDown={handleOnMouseDown}
                data-active={showSideModel}
                ref={ref}
            >
                {curRatioObj?.icon && <curRatioObj.icon className={styles.ratio_icon} />}
                {FJLocalStore._(curRatioObj?.name)}
                <ArrowIcon className={styles.arrow_icon} />
            </div>
        );
    };
    const renderOverlay = ({ ref }) => {
        return (
            <div className={styles.ratio_side_model} ref={ref} id='ratio-side-model'>
                <div className={styles.model_ratio_title}>{FJLocalStore._('aspect-ratio')}</div>

                <FJVerticalScroller className={styles.ratio_list_box}>
                    {list?.map(item => {
                        return (
                            <div
                                className={classNames(
                                    styles.ratio_item,
                                    item.name === curRatioObj?.name && styles.ratio_item_active,
                                )}
                                key={item.name}
                                onClick={() => handleChangeRatio(item.name)}
                            >
                                {item.icon && <item.icon className={styles.ratio_item_icon} />}
                                <div className={styles.ratio_item_name}>{FJLocalStore._(item.name)}</div>
                                {item.name === curRatioObj?.name && <CheckIcon className={styles.check_icon} />}
                            </div>
                        );
                    })}
                </FJVerticalScroller>
            </div>
        );
    };
    return (
        <div className={classNames(styles.ratio_box, className)}>
            <div className={styles.ratio_title}>{FJLocalStore._('aspect-ratio')}</div>

            <FJDropdownNew
                renderTrigger={renderTrigger}
                renderOverlay={renderOverlay}
                offsetLeft={20}
                offsetTop={-21}
                trigger='click'
                placement='rightTop'
                zIndex={FJUtil.isLandingPage() ? 4 : 999}
                useAnchorBody
                canTriggerActive
                onHide={() => setShowSideModel(false)}
                onShow={() => setShowSideModel(true)}
            />
        </div>
    );
};

FJRatioChoose.propTypes = {
    currentRatio: PropTypes.string,
    changeRatio: PropTypes.func,
    list: PropTypes.array,
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
};
export default FJRatioChoose;
